<template>
    <div
        ref="root"
        class="configbar"
        :class="{ 'configbar--slim': slim, 'configbar--inner': inner }"
    >
        <a
            class="configbar__button configbar__button--data"
            v-if="showData"
            v-on:click.prevent="$emit('open', 'data')"
            href="#"
            v-tooltip.left="$helpers.uiText('U011')"
            >Inhalt</a
        >
        <a
            class="configbar__button configbar__button--layout"
            v-if="showLayout"
            v-on:click.prevent="$emit('open', 'layout')"
            href="#"
            v-tooltip.left="$helpers.uiText('U012')"
            >Layout</a
        >
        <a
            class="configbar__button configbar__button--appearance"
            v-if="showAppearance"
            v-on:click.prevent="$emit('open', 'appearance')"
            href="#"
            v-tooltip.left="$helpers.uiText('U013')"
            >Aussehen</a
        >

        <div>
            <span></span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            observer: null
        };
    },
    components: {},
    methods: {},
    computed: {},
    watch: {},
    props: {
        showData: Boolean,
        showLayout: Boolean,
        showAppearance: Boolean,
        slim: Boolean,
        inner: Boolean
    },
    mounted() {},
    created() {}
};
</script>
